import { t } from 'i18next';
import React from 'react';
import { Card } from 'react-bootstrap';

const FaqCommonguide = () => {
  return (
    <div>
      <h3 className="mb-4">{t('header.text.text_16')}</h3>
      <Card>
        <Card.Body>
          <iframe
            src="https://docs.google.com/document/d/1xRm8-W_HaL35Jfgd-LMBaDCfoVO_3gGD3Alwcu7iqpU/preview"
            style={{ width: '100%', height: '600px', border: 'none' }}
            title="User Guide"
          ></iframe>
        </Card.Body>
      </Card>
    </div>
  );
};

export default FaqCommonguide;
